import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/home.vue';

Vue.use(Router);

export default new Router({
    mode   : 'history',
    base   : process.env.BASE_URL,
    routes : [
        {
            path      : '/',
            name      : 'home',
            component : Home,
            meta      : {
                showFooterNav  : false,
                useInFooterNav : false,
                viewName       : "Home"
            }
        },
        {
            path      : '/about',
            name      : 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component : () => import(/* webpackChunkName: "about" */ './views/about.vue'),
            meta      : {
                showFooterNav  : true,
                useInFooterNav : true,
                viewName       : "About"
            }
        },
        {
            path      : '/career',
            name      : 'career',
            component : () => import('./views/career.vue'),
            meta      : {
                showFooterNav  : true,
                useInFooterNav : true,
                viewName       : "Career"
            }
        },
        {
            path      : '/music',
            name      : 'music',
            component : () => import('./views/music.vue'),
            meta      : {
                showFooterNav  : true,
                useInFooterNav : true,
                viewName       : "Music"
            }
        },
        {
            path      : '/resume',
            name      : 'resume',
            component : () => import('./views/resume.vue'),
            props     : (route) => ({
                access    : route.query.access,
                format    : route.query.format,
                autoPrint : ['1', 'yes', 'true'].includes(route.query.print)
            }),
            meta : {
                showFooterNav  : false,
                useInFooterNav : false,
                viewName       : "Resume"
            }
        }
    ]
});
